function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloudy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB400"
    },
    d: "M346,106c-30.366,0-57.539,18.105-69.229,46.128c-3.193,7.646,0.425,16.421,8.071,19.614   l98.936,58.213c2.754,2.183,6.035,3.237,9.287,3.237c4.438,0,8.818-1.948,11.777-5.698C415.258,214.325,421,197.816,421,181   C421,139.647,387.353,106,346,106z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB400"
    },
    d: "M346,76c-8.291,0-15-6.709-15-15V31c0-8.291,6.709-15,15-15s15,6.709,15,15v30     C361,69.291,354.291,76,346,76z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB400"
    },
    d: "M497,196h-30c-8.291,0-15-6.709-15-15s6.709-15,15-15h30c8.291,0,15,6.709,15,15     S505.291,196,497,196z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB400"
    },
    d: "M430.858,111.142c-3.838,0-7.676-1.465-10.605-4.395c-5.859-5.859-5.859-15.352,0-21.211     l21.211-21.211c5.859-5.859,15.352-5.859,21.211,0s5.859,15.352,0,21.211l-21.211,21.211     C438.534,109.677,434.696,111.142,430.858,111.142z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB400"
    },
    d: "M261.142,111.142c-3.838,0-7.676-1.465-10.605-4.395l-21.211-21.211      c-5.859-5.859-5.859-15.352,0-21.211s15.352-5.859,21.211,0l21.211,21.211c5.859,5.859,5.859,15.352,0,21.211      C268.817,109.677,264.979,111.142,261.142,111.142z"
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD9F1"
    },
    d: "M451,286c0,49.501-40.499,90-90,90l-165-21L78.999,340C67.301,324.401,61,305.501,61,286   c0-49.501,40.499-90,90-90c3.3,0,6.599,0.3,9.901,0.601c7.8-17.1,20.099-31.501,35.099-41.7c17.1-12.001,37.8-18.9,60-18.9   c41.4,0,77.999,23.699,95.099,60.601C403.299,190.901,451,233.2,451,286z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD9F1"
    },
    d: "M451,286c0,49.501-40.499,90-90,90l-165-21V154.9c17.1-12.001,37.8-18.9,60-18.9   c41.4,0,77.999,23.699,95.099,60.601C403.299,190.901,451,233.2,451,286z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0F3FC"
    },
    d: "M291.099,316.601C273.999,279.699,237.4,256,196,256s-77.999,23.699-95.099,60.601     C48.401,310.901,0,353.2,0,406c0,49.501,41.499,90,91,90h210c49.501,0,90-40.499,90-90     C391,353.2,343.599,310.901,291.099,316.601z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0F3FC"
    },
    d: "M391,406c0,49.501-40.499,90-90,90H196V256c41.4,0,77.999,23.699,95.099,60.601   C343.599,310.901,391,353.2,391,406z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudy);
export default __webpack_public_path__ + "static/media/cloudy.24fc533d7d0e09a8b6e7625586b8ce66.svg";
export { ForwardRef as ReactComponent };